import { Component, Input, OnInit } from '@angular/core';

type Icon = 'equal' | 'up' | 'down';

@Component({
  selector: 'app-data-boxes',
  templateUrl: './data-boxes.component.html',
  styleUrls: ['./data-boxes.component.scss']
})

export class DataBoxesComponent implements OnInit {

  @Input()
  heading: string;

  @Input()
  count: Number

  @Input()
  className: string;

  @Input()
  icon?: Icon;

  @Input()
  footerMonth?: string;

  color = 'green';

  constructor() { }

  ngOnInit(): void {
  }

  getIconPath(icon : Icon) {
    switch(icon) {
      case 'equal' : return '../../../assets/images/icons/Equal.svg';
      case 'up' : return '../../../assets/images/icons/Form_chevron_up.svg';
      case 'down' : return '../../../assets/images/icons/Form_chevron_down.svg';
    }
  }

}
